export default __webpack_public_path__ + "static/media/bonanza-id.e3b38d31.webp";